export const EncKey = "nZr4u7x!";
export const GoogleAuthKey = "+KbPdSgV";
export const CurrencyApiKey = "5fe06140-841d-11ec-b73d-877d89661245";
export const AppUri = "http://localhost:3000";
export const ApiUri = "http://localhost:4000";
export const DocUri = "http://localhost:4000";

// export const AppUri = "https://app.adora.cloud";
// export const ApiUri = "https://app.adora.cloud/api";
